export const emailAlias = (email: string) => {
  return email.split('@')[0];
};
